import { render, staticRenderFns } from "./TextFab.vue?vue&type=template&id=5d9a223f&lang=pug&"
import script from "./TextFab.vue?vue&type=script&lang=js&"
export * from "./TextFab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TextFab.vue"
export default component.exports